<template>
  <v-container fill-height>
    <v-layout column>
      <v-alert :value="showPasswordBanner" type="warning">
        <v-layout row align-center>
          {{ this.$t("headers.password") }}
          <v-spacer />
          <v-flex :xs12="xsOnly">
            <v-layout :wrap="xsOnly" :justify-end="smAndUp">
              <v-btn text small color="white" :class="{ 'mr-7': xsOnly }" @click="$router.push({ name: routeNames.password.name })">
                {{ $t("actions.set_password") }}
              </v-btn>
              <v-btn text small color="white" :class="{ 'mr-4': smAndUp }" @click="dismissPasswordBanner()">
                {{ $t("actions.dismiss") }}
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-alert>
      <v-layout column justify-center align-center v-if="loadingBookings">
        <span class="grey--text title my-3 text-center">{{
          $t("main.loading_bookings")
        }}</span>
        <v-progress-circular color="primary" indeterminate />
      </v-layout>
      <v-layout column v-else-if="bookings.length">
        <ul id="dasboard-buttons">
          <li v-for="(item, index) in items" :key="index">
            <DashboardButton
              :title="item.name"
              :icon="item.icon"
              :url="item.url"
              :image="getImageFile(item.image)"
            />
          </li>
        </ul>
        <v-spacer/>
        <div v-if="urlCookiesPolicy || urlPrivacyPolicy" class="pa-2 text-center caption">
          <span v-if="urlCookiesPolicy" class="clickable underline" @click="openInNewTab({ route: urlCookiesPolicy, external: true })" v-text="$t('main.cookies_policy')" />
          <span v-if="urlPrivacyPolicy" class="clickable underline" @click="openInNewTab({ route: urlCookiesPolicy, external: true })" v-text="$t('main.privacy_policy')" :class="{ 'ml-2': urlCookiesPolicy }" />
        </div>
        <div class="grey--text pa-2 text-center caption">
          v{{pjson.version}} Copyright © easygoband World S.L. {{moment().format('YYYY')}}
        </div>
      </v-layout>
      <v-layout
        v-else
        column
        align-center
        justify-center
        class="grey--text text--lighten-1 display-1 text-center"
        >{{ $t("main.no_bookings") }}
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { URL_COOKIES_POLICY, URL_PRIVACY_POLICY } from '@/config/environment'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { getFileURL } from '@/lib/helpers/FileURLGetter'
import routingMixins from '@/mixins/Routing'
import vuetifyMixins from '@/mixins/Vuetify'
import routeNames from '@/router/routes'
import pjson from '@/../package.json'

import moment from 'moment'

export default {
  data () {
    return {
      moment,
      pjson,
      loadingBookings: true,
      routeNames,
      showPasswordBanner: false,
      urlCookiesPolicy: URL_COOKIES_POLICY,
      urlPrivacyPolicy: URL_PRIVACY_POLICY,
    }
  },
  computed: {
    ...mapState({
      bookings: (state) => state.me.bookings,
    }),
    ...mapGetters({
      skipRegisterGuestTypes: 'service/skipRegisterGuestTypeIds',
    }),
    items () {
      if (this.$store.state.service.configuration === null) {
        return null
      }
      const items = this.$store.state.service.configuration.dashboardItems
      const itemsEnabled = items.filter((item) => item.enabled === true && !(item.url === '/checkin' && this.skipCheckIn))
      return itemsEnabled.map(function (item) {
        return {
          name: getTextValue(item.name),
          icon: item.icon,
          image: item.coverImage,
          url: item.url,
        }
      })
    },
    settings () {
      return this.$store.state.me.settings
    },
    skipCheckIn () {
      return this.bookings && this.bookings.every(({ guests }) => {
        return guests.every(({ guest }) => {
          return this.skipRegisterGuestTypes.includes(guest.typeId)
        })
      })
    },
  },
  methods: {
    getImageFile (id) {
      return getFileURL(id)
    },
    dismissPasswordBanner () {
      localStorage.setItem('dismissedForToken', localStorage.getItem('token'))
      this.showPasswordBanner = false
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (!newValue) {
          return
        }
        if (
          !newValue.hasPassword &&
          (!localStorage.getItem('dismissedForToken') ||
            localStorage.getItem('dismissedForToken') !==
              localStorage.getItem('token'))
        ) {
          this.showPasswordBanner = true
        }
      },
    },
  },
  async created () {
    if (this.bookings === null) {
      await this.$store.dispatch('me/getBookings')
    }
    this.loadingBookings = false
  },
  components: {
    DashboardButton: () => import('@/components/app-components/DashboardButton.vue'),
  },
  mixins: [routingMixins, vuetifyMixins],
}
</script>

<style lang="scss">
#dasboard-buttons {
  list-style: none;
  padding: 0;

  li {
    width: 100%;
    display: inline-block;
    padding: 8px;
  }
}

@media (min-width: 600px) {
  #dasboard-buttons {
    li {
      width: 50%;
    }
  }
}

@media (min-width: 800px) {
  #dasboard-buttons {
    li {
      width: calc(100% / 3);
    }
  }
}

@media (min-width: 1264px) {
  #dasboard-buttons {
    li {
      width: 25%;
    }
  }
}
</style>
